import React from "react";
import { useParams } from "react-router-dom";
import Theme404 from "../../layout/404";

import prompt_list from "./prompt.list";
import prompt_edit from "./prompt.edit";
import prompt_import from "./prompt.import";

/**
 *   Create index file for Prompt
 */

export default function List_prompt() {
  let useParam = {} as any;
  useParam = useParams();
  let Param = useParam.slug || "list";

  let ActualPage: any;
  switch (Param) {
    case "list":
      ActualPage = prompt_list;
      break;

    case "edit":
      ActualPage = prompt_edit;
      break;

    case "new":
      ActualPage = prompt_edit;
      break;

    case "import":
      ActualPage = prompt_import;
      break;

    default:
      ActualPage = Theme404;
      break;
  }

  return <ActualPage />;
}
